import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './set_pro.component.html'
})
export class SetProModalComponent extends BaseSupportModalComponent {
	userId: string;
	pro: boolean;

	async ok() {
		await this.supportService.setPro(this.userId, !this.pro, this.spreader.base.comment).toPromise();

		this.execute();
	}
}
